import { Link } from 'react-router-dom'
import classes from './ErrorPage.module.css'

const ErrorPage = () => {
    return <div className={classes.error_page_container}>
        <div className={classes.error_page_container_inner}>
            <div className={classes.icon}>
                <i className='ti ti-error-404'></i>
            </div>
            <div className={classes.text}>
                <h1>Page not found!</h1>
                <p>Return to <Link to="/dashboard">dashboard</Link></p>
            </div>
        </div>
    </div>
}

export default ErrorPage